import { createBrowserHistory } from 'history'
import { RouterPaths } from "./constant"
import { getshoplink } from "../service/shop"
import { getSearch } from './utils'

export const history = createBrowserHistory()
export function pushUrl (path: string) {
  history.push(path)
}

export function getPathName () {
  return history.location.pathname
}

export const redirectUrl = async (url) => {
  if(url === RouterPaths['shop']){
    try {
      const res = await getshoplink()
      if(res.code === 0) {
        window.location.replace(res.links[getSearch('type')])
      }else{
        window.location.href = url
      }
    } catch (error) {
      window.location.href = url
    }
  }else {
    window.location.href = url
  }
}

